import axios from "axios";
import { toast } from "react-toastify";
import { token } from "./components/header.tsx";

export const getRequest = async (reqURL) => {
  try {
    const { status, data } = await axios.get(
      `${reqURL}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : null
    );
    if (status === 200) {
      return { data: data };
    }
  } catch (err) {
    if (err.response.status === 401) {
      setTimeout(() => {
        window.location.replace("/login");
      }, 2000);
      toast.error("لطفا دوباره وارد شوید!");
    } else if (err.response.status === 404) {
      return { error: "درخواست مورد نظر یافت نشد!" };
    } else if (err.response.status === 500) {
      return { error: "خطا در سرور رخ داد!" };
    } else if (err.response.status === 400) {
      return { error: "درخواست مورد نظر امکان پذیر نیست!" };
    }
  }
};

export const postRequest = async (reqURL, postData) => {
  try {
    const { status, data } = await axios.post(
      `${reqURL}`,
      postData,
      token ? { headers: { Authorization: `Bearer ${token}` } } : null
    );
    if (status === 200) {
      return { data: data, message: "ok" };
    }
  } catch (err) {
    if (err.response.status === 401) {
      if (document.URL.split("/").at(-1) === "login") {
        toast.error("نام کاربری یا رمز عبور اشتباه است!");
      } else {
        setTimeout(() => {
          window.location.replace("/login");
        }, 2000);
        toast.error("لطفا دوباره وارد شوید!");
      }
    } else if (err.response.status === 404) {
      return { error: "درخواست مورد نظر یافت نشد!" };
    }
  }
};

export const deleteRequest = async (reqURL) => {
  try {
    const data = await axios.delete(
      `${reqURL}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : null
    );
    if (data.status === 200) {
      return { status: data.status, error: "" };
    }
  } catch (err) {
    if (err.response.status === 401) {
      setTimeout(() => {
        window.location.replace("/login");
      }, 2000);
      toast.error("لطفا دوباره وارد شوید!");
    } else if (err.response.status === 404) {
      return { error: "درخواست مورد نظر یافت نشد!" };
    } else if (err.response.status === 500) {
      return { error: "خطا در سرور رخ داد!" };
    } else if (err.response.status === 400) {
      return { error: "درخواست مورد نظر مکان پذیر نیست!" };
    }
  }
};
